import '../common/_common';
import './product/_slider';
import printProduct from './product/_print';

printProduct();

if (process.env.NODE_ENV === 'development') {
    require('/src/html/pages/product.html')
    console.log('development mode');
}